import axiosClient from '../../configs/axios.js';


class FinishGoodInvotryRepot {
    // Get list 
    async getFinishGoodInvotryRepotrepotlist(params) {
        try {
            const response = await axiosClient.get(
                `/reports/FinishGood?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }





 








   
    
}

export default new FinishGoodInvotryRepot(); 